module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTg2NCA5NmE2NCA2NCAwIDAgMSA2NCA2NHY3MDRhNjQgNjQgMCAwIDEtNjQgNjRIMTYwYTY0IDY0IDAgMCAxLTY0LTY0VjE2MGE2NCA2NCAwIDAgMSA2NC02NGg3MDR6TTU0Mi4zIDIzMy4yYTMyIDMyIDAgMCAwLTQyLjItMi43bC0zIDIuNy0xMzUuOCAxMzUuN2EzMiAzMiAwIDAgMCA0Mi4yIDQ3LjlsMy0yLjcgODEuMS04MS4yVjc2OGEzMiAzMiAwIDAgMCAyOC4zIDMxLjhsMy43IDAuMmEzMiAzMiAwIDAgMCAzMS44LTI4LjNMNTUxLjcgNzY4VjI1NS41YTMxLjcgMzEuNyAwIDAgMC05LjMtMjIuMnoiIGZpbGw9IiMwIiBwLWlkPSIzMjcxIj48L3BhdGg+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Ascending-filled.svg
// module id = BP/7
// module chunks = 75